<template>
    <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        persistent
        @keydown.esc="cerrarDialog()"
    >
        <v-card tile>
            <v-toolbar flat dark color="primary">
                <v-btn icon dark @click="cerrarDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>
                    <span> {{ cliente.code }} - {{ cliente.name }}</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-menu bottom right offset-y> </v-menu>
            </v-toolbar>
            <v-card>
                <v-alert
                    class="mt-4 ml-6 mr-6"
                    dense
                    outlined
                    border="left"
                    :color="avisoContratos.nivelAlertaContrato.color"
                    :icon="avisoContratos.nivelAlertaContrato.icono"
                    v-if="cliente.name && avisoContratos && avisoContratos.horas < 0"
                >
                    {{ cliente.name }} tiene contratos en negativo <span v-if="avisoContratos.nivelAlertaContrato.rango !='info'">que se encuentran por encima del umbral máximo</span>
                </v-alert>
                <v-alert
                    class="mt-4 ml-6 mr-6"
                    dense
                    outlined
                    border="left"
                    type="info"
                    icon="mdi-information-outline"
                    v-if="cliente.observaciones && cliente.observaciones !== ''"
                >
                    Observaciones del cliente: {{ cliente.observaciones }}
                </v-alert>
                <v-card-text>
                    <v-card outlined :loading="loading">
                        <v-card-subtitle>Información del cliente</v-card-subtitle>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field
                                        label="CIF"
                                        v-model="cliente.cif"
                                        readonly
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field
                                        label="Teléfono"
                                        v-model="cliente.phone"
                                        readonly
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field
                                        label="Email"
                                        v-model="cliente.emailPrincipal"
                                        readonly
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field
                                        label="Facturas pendientes"
                                        v-model="cliente.facturas.facturasPendientes"
                                        readonly
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field
                                        label="Importe pendiente"
                                        v-model="cliente.facturas.importePendiente"
                                        readonly
                                        type="number"
                                        prefix="€"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="6" md="4">
                                    <v-autocomplete
                                        v-model="comercial"
                                        :items="comerciales"
                                        chips
                                        label="Comercial"
                                        item-text="nombre"
                                        item-value="id"
                                        readonly
                                        append-icon=""
                                    >
                                        <template v-slot:selection="data">
                                            <v-chip
                                                v-bind="data.attrs"
                                                :input-value="data.selected"
                                            >
                                                <v-avatar left :color="data.item.color">
                                                <span class="white--text">{{
                                                    data.item.avatar
                                                }}</span>
                                                </v-avatar>
                                                {{ data.item.nombre + " " + data.item.apellidos }}
                                            </v-chip>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-autocomplete
                                        v-model="responsableCuenta"
                                        :items="tecnicos"
                                        chips
                                        label="Responsable técnico"
                                        item-text="nombre"
                                        item-value="id"
                                        readonly
                                        append-icon=""
                                    >
                                        <template v-slot:selection="data">
                                            <v-chip
                                                v-bind="data.attrs"
                                                :input-value="data.selected"
                                            >
                                                <v-avatar left :color="data.item.color">
                                                <span class="white--text">{{
                                                    data.item.avatar
                                                }}</span>
                                                </v-avatar>
                                                {{ data.item.nombre + " " + data.item.apellidos }}
                                            </v-chip>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-autocomplete
                                        v-model="tecnicoReferencia"
                                        :items="tecnicos"
                                        chips
                                        label="Técnico de referencia"
                                        item-text="nombre"
                                        item-value="id"
                                        readonly
                                        append-icon=""
                                    >
                                        <template v-slot:selection="data">
                                            <v-chip
                                                v-bind="data.attrs"
                                                :input-value="data.selected"
                                            >
                                                <v-avatar left :color="data.item.color">
                                                <span class="white--text">{{
                                                    data.item.avatar
                                                }}</span>
                                                </v-avatar>
                                                {{ data.item.nombre + " " + data.item.apellidos }}
                                            </v-chip>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-autocomplete
                                        v-model="equipoTecnico"
                                        :items="equipoTecnico"
                                        chips
                                        multiple
                                        label="Equipo técnico"
                                        item-text="nombre"
                                        item-value="id"
                                        readonly
                                        append-icon=""
                                    >
                                        <template v-slot:selection="data">
                                            <v-chip
                                                v-bind="data.attrs"
                                                :input-value="data.selected"
                                            >
                                                <v-avatar left :color="data.item.color">
                                                <span class="white--text">{{
                                                    data.item.avatar
                                                }}</span>
                                                </v-avatar>
                                                {{ data.item.nombre + " " + data.item.apellidos }}
                                            </v-chip>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                        <v-card outlined class="mt-4" :loading="loading">
                            <v-card-subtitle>Contactos</v-card-subtitle>
                            <v-card-text>
                                <v-data-table
                                    dense
                                    :headers="headerContactos"
                                    :items="cliente.contactos"
                                ></v-data-table>
                            </v-card-text>
                        </v-card>
                        <v-card outlined class="mt-4" :loading="loading">
                            <v-card-subtitle>Facturas pendientes</v-card-subtitle>
                            <v-card-text>
                                <v-data-table
                                    dense
                                    :headers="headerFacturas"
                                    :items="cliente.facturas.facturas"
                                ></v-data-table>
                            </v-card-text>
                        </v-card>
                        <resumen-cliente
                            class="mt-4"
                            v-bind:loading="loading"
                        />                       
                </v-card-text>
            </v-card>
        </v-card>
    </v-dialog>
</template>

<script>
    import buscarEquipoCliente from "@/mixins/buscarEquipoCliente";
    import { mapActions, mapGetters } from 'vuex';
    import axios from 'axios';
    axios.defaults.baseURL = process.env.VUE_APP_API_URL;
    import ResumenCliente from "../resumen/resumenCliente.vue";
    export default {
        name: 'ClienteDialog',
        components: {
            'resumen-cliente': ResumenCliente,
        },
        mixins: [ buscarEquipoCliente ],
        data() {
            return {
                fechaHoy: new Date().toISOString().substr(0, 10),
                dialog: true,
                loading: true,
                cliente: {
                    facturas: {}
                },
                headerTecnicos: [
                    {
                        text: 'Técnico',
                        sortable: true,
                        value: 'name'
                    }
                ],
                headerContactos: [
                    {
                        text: 'Nombre',
                        sortable: true,
                        value: 'name'
                    },
                    {
                        text: 'Email',
                        sortable: true,
                        value: 'email'
                    },
                ],
                headerFacturas: [
                    {
                        text: 'Núm.',
                        sortable: true,
                        value: 'documentNo'
                    },
                    {
                        text: 'Concepto',
                        sortable: true,
                        value: 'concepto'
                    },
                    {
                        text: 'Fecha registro',
                        sortable: true,
                        value: 'fechaRegistro'
                    },
                    {
                        text: 'Fecha Vto.',
                        sortable: true,
                        value: 'fechaVto'
                    },
                    {
                        text: 'Importe',
                        sortable: true,
                        value: 'importe'
                    },
                    {
                        text: 'Importe pendiente',
                        sortable: true,
                        value: 'importePendiente'
                    },
                ],
                responsableCuenta: {},
                tecnicoReferencia: {},
                equipoTecnico: []
            }
        },
        methods: {
            ...mapActions('contratos', ['getEstadoContratosCliente', 'setContratosCliente']),
            cerrarDialog(){
                this.$emit('close');
                this.setContratosCliente([]);
            }
        },
        async mounted(){
            let codCliente = this.$route.params.id;
            let respuesta = await axios.get(`api/clientes/${codCliente}`);
            this.cliente = respuesta.data;
            respuesta = await this.buscarEquipoCliente(codCliente);
            if(!respuesta.error){
                let datosEquipoCliente = respuesta;
                this.responsableCuenta = datosEquipoCliente.responsableCuenta;
                this.tecnicoReferencia = datosEquipoCliente.tecnicoReferencia;
                this.equipoTecnico = datosEquipoCliente.equipoTecnico;
            }
            await this.getEstadoContratosCliente([this.fechaHoy, codCliente]);
            this.loading = false;
        },
        computed: {
            ...mapGetters({
                comerciales: "usuarios/comerciales", 
                estadoContratos: "contratos/estadoContratos"
            }),
            comercial(){
                return this.comerciales.find(comercial => comercial.email === this.cliente.comercialEmail);
            },
            avisoContratos(){
                if(this.estadoContratos.length > 0){
                    let estadoContratoCritico = this.estadoContratos.find(contrato => contrato.horas < 0 && contrato.nivelAlertaContrato.rango === 'critico');
                    if(estadoContratoCritico) return estadoContratoCritico;
                    
                    let estadoContratoAlerta = this.estadoContratos.find(contrato => contrato.horas < 0 && contrato.nivelAlertaContrato.rango === 'alerta');
                    if(estadoContratoAlerta) return estadoContratoAlerta;

                    let estadoContratoInfo = this.estadoContratos.find(contrato => contrato.horas < 0 && contrato.nivelAlertaContrato.rango === 'info');
                    if(estadoContratoInfo) return estadoContratoInfo;
                }
            }
        }
    }
</script>
